import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";

class ProgressBar extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	static defaultProps = {
		percent: 0,
		width: 0,
		height: 5
	};

	static propTypes = {
		/** Percent (number) of progress completed */
		percent: PropTypes.number,
		/** Bar width  */
		width: PropTypes.number,
		/** Bar height */
		height: PropTypes.number
	};

	getColor = () => {
		const {percent} = this.props;
		return percent === 100 ? 'green' : percent > 50 ? 'lightgreen' : 'red';
	};

	getWidthAsPercentOfTotalWidth = () => {
		const {percent, width} = this.props;
		return parseInt(width * ( percent / 100 ), 10);
	};


	render() {
		const { width, height} = this.props;
		const rootStyle = {
			border: 'solid 1px lightgray',
			width
		};
		const innerStyle = {
			width: this.getWidthAsPercentOfTotalWidth(),
			height,
			backgroundColor: this.getColor()
		};
		return (
			<div style={rootStyle}>
				<div style={innerStyle} />
			</div>
		);
	}
}

export default ProgressBar;
